import Hero from '@/components/sections/Hero';
import Story from '@/components/sections/Story';
import Press from '@/components/sections/Press';
import Features from '@/components/sections/Features';
import Pricing from '@/components/sections/Pricing';
import Download from '@/components/sections/Download';
import Registration from '@/components/sections/Registration';
import Footer from '@/components/sections/Footer';

export default function Landing() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Hero />
      <Story />
      <Press />
      <Features />
      <Pricing />
      <Download />
      <Registration />
      <Footer />
    </div>
  );
}
